import "./Projects.module.css";
import Header from "@/reusable_sections/Header";
import Projects from "./sections/Projects";
import ProjectsShowcase from "./sections/ProjectsShowcase";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function ProjectsPage() {
  return <div>
      <Header />
      <Projects />
      <ProjectsShowcase />
      <Consultation />
      <Footer />
    </div>;
}